import { MiscInvoiceHistoryToolPanel } from "../MiscInvoiceHistoryToolPanel";
import { DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceHistoryList extends Layout {
    layoutMiscInvoiceHistoryToolPanel: MiscInvoiceHistoryToolPanel;
    searchpanelSearch: SearchPanel;
    sourceMiscBillHist: DataSource;
    tableMiscInvoicingHistory: Table;
    textboxBillDateSearch: Textbox;
    textboxBillTypeSearch: Textbox;
    textboxBillingUserSearch: Textbox;
    textboxCurrencySearch: Textbox;
    textboxCustomerIdSearch: Textbox;
    textboxInvoiceNoStringSearch: Textbox;
    textboxOrderIdSearch: Textbox;
    textboxReferenceNumberSearch: Textbox;
    textboxTotalChargesSearch: Textbox;
}
